import { useState, useEffect, useRef } from "react";

const NAV_LINKS = ["Services", "About", "Process", "Contact"];

const SERVICES = [
  {
    icon: "✦",
    title: "USPS Rate Consulting",
    desc: "We analyze your mail volume, class, and routes to find the lowest possible postage rates — guaranteed.",
  },
  {
    icon: "◈",
    title: "Presort & Preparation",
    desc: "End-to-end presort services that qualify your mail for automation discounts and bypass unnecessary surcharges.",
  },
  {
    icon: "◉",
    title: "Compliance & Audit",
    desc: "Stay ahead of USPS regulations. We audit your mail programs and flag costly errors before they happen.",
  },
  {
    icon: "⬡",
    title: "Direct Mail Strategy",
    desc: "From list hygiene to format optimization, we engineer campaigns that land, not just arrive.",
  },
];

const STATS = [
  { value: "38%", label: "Average postage savings" },
  { value: "2.4B+", label: "Pieces processed" },
  { value: "99.1%", label: "USPS compliance rate" },
  { value: "18yrs", label: "Industry expertise" },
];

const PROCESS = [
  { num: "01", title: "Mail Audit", desc: "We review your current spend, mail classes, and vendor relationships to find the gaps." },
  { num: "02", title: "Strategy Design", desc: "Our consultants build a custom postal plan aligned to your volume, cadence, and budget." },
  { num: "03", title: "Implementation", desc: "We work directly with USPS and your print vendors to execute the plan without disruption." },
  { num: "04", title: "Ongoing Optimization", desc: "Postal rates change. We monitor, adapt, and keep your savings compounding year over year." },
];

export default function Postratics() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const heroRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div style={{ fontFamily: "'Georgia', 'Times New Roman', serif", background: "#F5F2EB", color: "#1A1714", minHeight: "100vh", overflowX: "hidden" }}>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;700;900&family=DM+Sans:wght@300;400;500&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .pf { font-family: 'Playfair Display', Georgia, serif; }
        .dm { font-family: 'DM Sans', sans-serif; }

        .nav-link {
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          font-weight: 500;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #1A1714;
          text-decoration: none;
          opacity: 0.65;
          transition: opacity 0.2s;
        }
        .nav-link:hover { opacity: 1; }

        .cta-btn {
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          font-weight: 500;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          background: #1A1714;
          color: #F5F2EB;
          border: none;
          padding: 14px 32px;
          cursor: pointer;
          transition: background 0.2s, transform 0.15s;
        }
        .cta-btn:hover { background: #3D2B1F; transform: translateY(-1px); }

        .cta-btn-outline {
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          font-weight: 500;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          background: transparent;
          color: #F5F2EB;
          border: 1px solid rgba(245,242,235,0.5);
          padding: 14px 32px;
          cursor: pointer;
          transition: border-color 0.2s, transform 0.15s;
        }
        .cta-btn-outline:hover { border-color: #F5F2EB; transform: translateY(-1px); }

        .service-card {
          background: #EDEAE0;
          border: 1px solid rgba(26,23,20,0.1);
          padding: 40px 36px;
          transition: background 0.3s, transform 0.2s;
          cursor: default;
        }
        .service-card:hover {
          background: #1A1714;
          color: #F5F2EB;
          transform: translateY(-4px);
        }
        .service-card:hover .svc-desc { color: rgba(245,242,235,0.7); }

        .process-num {
          font-family: 'Playfair Display', serif;
          font-size: 72px;
          font-weight: 900;
          color: rgba(26,23,20,0.08);
          line-height: 1;
          margin-bottom: -16px;
        }

        .ticker-wrap {
          overflow: hidden;
          background: #1A1714;
          padding: 14px 0;
          white-space: nowrap;
        }
        .ticker-inner {
          display: inline-block;
          animation: ticker 28s linear infinite;
        }
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .stamp-decoration {
          border: 3px double rgba(26,23,20,0.15);
          padding: 6px;
        }

        .divider-mark {
          width: 48px;
          height: 2px;
          background: #C4873A;
          margin: 24px 0;
        }

        .hero-label {
          font-family: 'DM Sans', sans-serif;
          font-size: 11px;
          letter-spacing: 0.25em;
          text-transform: uppercase;
          opacity: 0.5;
        }

        .fade-in {
          animation: fadeUp 0.7s ease both;
        }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .nav-links-desktop { display: flex; gap: 40px; align-items: center; }
        .hamburger { display: none; background: none; border: none; cursor: pointer; padding: 4px; }
        .mobile-menu {
          display: none; flex-direction: column; gap: 0;
          position: fixed; top: 64px; left: 0; right: 0;
          background: #F5F2EB; border-bottom: 1px solid rgba(26,23,20,0.1);
          z-index: 99; padding: 16px 0;
        }
        .mobile-menu.open { display: flex; }
        .mobile-menu a, .mobile-menu button {
          padding: 14px 24px; font-family: 'DM Sans', sans-serif;
          font-size: 15px; font-weight: 500; letter-spacing: 0.05em;
          text-transform: uppercase; color: #1A1714; text-decoration: none;
          opacity: 0.7; background: none; border: none; text-align: left; cursor: pointer;
        }

        .stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 1px; background: rgba(245,242,235,0.08); }
        .stat-cell { padding: 40px 36px; background: #1A1714; }
        .services-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 1px; background: rgba(26,23,20,0.1); }
        .process-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 1px; background: rgba(26,23,20,0.1); }
        .about-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
        .services-header { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 60px; }
        .footer-inner { display: flex; justify-content: space-between; align-items: center; }
        .footer-links { display: flex; gap: 40px; }

        @media (max-width: 900px) {
          .nav-links-desktop { display: none; }
          .hamburger { display: block; }
          .stats-grid { grid-template-columns: repeat(2, 1fr); }
          .process-grid { grid-template-columns: repeat(2, 1fr); }
          .about-grid { grid-template-columns: 1fr; gap: 40px; }
          .services-header { flex-direction: column; align-items: flex-start; gap: 20px; }
          .services-header > div:last-child { text-align: left !important; }
        }

        @media (max-width: 600px) {
          .stats-grid { grid-template-columns: 1fr; }
          .stat-cell { padding: 16px 20px !important; display: flex; align-items: center; gap: 16px; }
          .stat-cell .stat-val { font-size: 28px !important; margin-bottom: 0 !important; }
          .services-grid { grid-template-columns: 1fr; }
          .process-grid { grid-template-columns: 1fr; }
          .footer-inner { flex-direction: column; gap: 24px; text-align: center; }
          .footer-links { flex-wrap: wrap; justify-content: center; gap: 20px; }
          .section-pad { padding: 64px 24px !important; }
          .hero-pad { padding: 30px 24px 56px !important; }
          .stats-pad { padding: 48px 24px !important; }
          .nav-pad { padding: 20px 24px !important; }
          .cta-stack { flex-direction: column; align-items: stretch !important; }
          .cta-stack button { text-align: center; }
        }
          .decorative-envelope {
  position: absolute;
  top: 100px;
  right: 0px;
  opacity: 0.08;
  font-size: 320px;
  line-height: 1;
  font-family: Georgia, serif;
  font-weight: 700;
  pointer-events: none;
  user-select: none;
  color: #1A1714;
  z-index: 0;           /* make sure it's behind content */
}

/* ================== RESPONSIVE ================== */

@media (max-width: 1024px) {
  .decorative-envelope {
    font-size: 120px;
    right: 0px;
    top:80px;
  }
}

@media (max-width: 610px) {
  .decorative-envelope {
    font-size: 100px;      /* smaller on tablets & mobiles */
    right: 0px;
    top: 158px;
      opacity:0;
  }
}

@media (max-width: 480px) {
  .decorative-envelope {
    font-size: 100px;      /* good size for phones */
    right: 0px;
    top: 158px;
  opacity:0;
  }
}

/* Very small screens */
@media (max-width: 360px) {
  .decorative-envelope {
  opacity:0;
  }
}
      `}</style>

      {/* NAV */}
      <nav style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 100,
        padding: "20px 60px",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        background: scrolled || menuOpen ? "rgba(245,242,235,0.97)" : "transparent",
        backdropFilter: scrolled ? "blur(12px)" : "none",
        borderBottom: scrolled ? "1px solid rgba(26,23,20,0.08)" : "none",
        transition: "all 0.3s"
      }} className="nav-pad">
        <div style={{ display: "flex", alignItems: "baseline", gap: "6px" }}>
          <span className="pf" style={{ fontSize: "22px", fontWeight: 700, letterSpacing: "-0.02em" }}>Postratics</span>
          <span className="dm" style={{ fontSize: "10px", letterSpacing: "0.2em", textTransform: "uppercase", opacity: 0.4, marginLeft: "4px" }}>™</span>
        </div>
        <div className="nav-links-desktop">
          {NAV_LINKS.map(l => <a key={l} href="#" className="nav-link">{l}</a>)}
          <button className="cta-btn" style={{ padding: "10px 24px", fontSize: "12px" }}>Get a Quote</button>
        </div>
        <button className="hamburger" onClick={() => setMenuOpen(o => !o)} aria-label="Toggle menu">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1A1714" strokeWidth="1.5" strokeLinecap="round">
            {menuOpen ? <><line x1="4" y1="4" x2="20" y2="20"/><line x1="20" y1="4" x2="4" y2="20"/></> : <><line x1="3" y1="7" x2="21" y2="7"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="17" x2="21" y2="17"/></>}
          </svg>
        </button>
      </nav>

      {/* MOBILE MENU */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        {NAV_LINKS.map(l => <a key={l} href="#" onClick={() => setMenuOpen(false)}>{l}</a>)}
        <button className="cta-btn" style={{ margin: "8px 24px", textAlign: "center" }}>Get a Quote</button>
      </div>

      {/* TICKER */}
      <div style={{ paddingTop: "80px" }}>
        <div className="ticker-wrap">
          <div className="ticker-inner">
            {Array(2).fill(null).map((_, i) => (
              <span key={i} className="dm" style={{ fontSize: "11px", letterSpacing: "0.2em", textTransform: "uppercase", color: "#F5F2EB", opacity: 0.7 }}>
                {["USPS Consulting", "Presort Services", "Postage Optimization", "Direct Mail Strategy", "Compliance Audits", "Rate Analysis", "Mail Program Design"].map(t => (
                  <span key={t} style={{ marginRight: "60px" }}>{t} &nbsp;·&nbsp;</span>
                ))}
              </span>
            ))}
          </div>
        </div>
      </div>
<div
  style={{
    maxWidth: '80%',
    margin: '50px auto 100px auto',
    
  }}
>
      {/* HERO */}
      <section ref={heroRef} style={{ padding: "100px 15%px 80px", position: "relative", overflow: "hidden" }} className="hero-pad">
        {/* BG postal pattern */}
        <div style={{
          position: "absolute", top: 0, right: 0, width: "480px", height: "480px",
          background: "radial-gradient(circle, rgba(196,135,58,0.06) 0%, transparent 70%)",
          pointerEvents: "none"
        }} />
<div className="decorative-envelope">✉</div>
        <div style={{ maxWidth: "900px", position: "relative" }}>
          <p className="hero-label fade-in" style={{ animationDelay: "0s" }}>Postal Intelligence for Modern Business</p>
          <div className="divider-mark fade-in" style={{ animationDelay: "0.1s" }} />
          <h1 className="pf fade-in" style={{
            fontSize: "clamp(52px, 7vw, 96px)",
            fontWeight: 900,
            lineHeight: 1.02,
            letterSpacing: "-0.03em",
            marginBottom: "32px",
            animationDelay: "0.15s"
          }}>
            The mail<br />
            doesn't have to<br />
            <em style={{ color: "#C4873A", fontStyle: "italic" }}>cost this much.</em>
          </h1>
          <p className="dm fade-in" style={{
            fontSize: "18px",
            fontWeight: 300,
            lineHeight: 1.7,
            maxWidth: "520px",
            opacity: 0.75,
            marginBottom: "48px",
            animationDelay: "0.25s"
          }}>
            Postratics is a USPS consulting firm that cuts postage spend, eliminates compliance risk, and rebuilds your mail program from the ground up — without disrupting your operations.
          </p>
          <div className="fade-in cta-stack" style={{ display: "flex", gap: "16px", flexWrap: "wrap", animationDelay: "0.35s" }}>
            <button className="cta-btn">Schedule a Free Audit →</button>
            <button className="dm" style={{
              fontSize: "13px", fontWeight: 500, letterSpacing: "0.08em",
              textTransform: "uppercase", background: "transparent", border: "none",
              padding: "14px 24px", cursor: "pointer", opacity: 0.55,
              textDecoration: "underline", textUnderlineOffset: "4px"
            }}>See how it works</button>
          </div>
        </div>
      </section>

      {/* STATS BAND */}
      <section style={{ background: "#1A1714", padding: "64px 60px" }} className="stats-pad">
        <div className="stats-grid">
          {STATS.map((s, i) => (
            <div key={i} className="stat-cell" style={{ textAlign: i > 0 ? "center" : "left" }}>
              <div className="pf stat-val" style={{ fontSize: "52px", fontWeight: 900, color: "#C4873A", lineHeight: 1, marginBottom: "10px" }}>{s.value}</div>
              <div className="dm" style={{ fontSize: "12px", letterSpacing: "0.15em", textTransform: "uppercase", color: "rgba(245,242,235,0.5)" }}>{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* SERVICES */}
      <section id="services" style={{ padding: "100px 60px" }} className="section-pad">
        <div className="services-header">
          <div>
            <p className="hero-label" style={{ marginBottom: "16px" }}>What we do</p>
            <h2 className="pf" style={{ fontSize: "clamp(36px, 4vw, 56px)", fontWeight: 700, lineHeight: 1.1, letterSpacing: "-0.02em" }}>
              Your mail program<br />is leaking money.<br /><em style={{ color: "#C4873A", fontStyle: "italic" }}>We find it.</em>
            </h2>
          </div>
          <div style={{ maxWidth: "320px", textAlign: "right" }}>
            <p className="dm" style={{ fontSize: "15px", lineHeight: 1.7, opacity: 0.6, fontWeight: 300 }}>
              We specialize exclusively in USPS postal strategy — not printing, not fulfillment. Just mail, done right.
            </p>
          </div>
        </div>
        <div className="services-grid">
          {SERVICES.map((s, i) => (
            <div key={i} className="service-card">
              <div style={{ fontSize: "24px", marginBottom: "20px", color: "#C4873A" }}>{s.icon}</div>
              <h3 className="pf" style={{ fontSize: "24px", fontWeight: 700, marginBottom: "14px", letterSpacing: "-0.01em" }}>{s.title}</h3>
              <p className="dm svc-desc" style={{ fontSize: "15px", lineHeight: 1.7, opacity: 0.65, fontWeight: 300, transition: "color 0.3s" }}>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* PROCESS */}
      <section id="process" style={{ background: "#EDEAE0", padding: "100px 60px" }} className="section-pad">
        <p className="hero-label" style={{ marginBottom: "16px" }}>How it works</p>
        <div className="divider-mark" />
        <h2 className="pf" style={{ fontSize: "clamp(36px, 4vw, 56px)", fontWeight: 700, letterSpacing: "-0.02em", marginBottom: "72px" }}>
          From audit to savings<br />in four steps.
        </h2>
        <div className="process-grid">
          {PROCESS.map((p, i) => (
            <div key={i} style={{ background: "#EDEAE0", padding: "36px 28px" }}>
              <div className="process-num">{p.num}</div>
              <h3 className="pf" style={{ fontSize: "20px", fontWeight: 700, marginBottom: "12px", letterSpacing: "-0.01em" }}>{p.title}</h3>
              <p className="dm" style={{ fontSize: "14px", lineHeight: 1.7, opacity: 0.6, fontWeight: 300 }}>{p.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ABOUT PULL QUOTE */}
      <section style={{ padding: "100px 60px" }} className="section-pad">
        <div className="about-grid">
          <div>
            <p className="hero-label" style={{ marginBottom: "16px" }}>About Postratics</p>
            <div className="divider-mark" />
            <p className="pf" style={{ fontSize: "clamp(22px, 2.5vw, 34px)", fontWeight: 500, lineHeight: 1.45, letterSpacing: "-0.01em", marginBottom: "32px" }}>
             "Independent Postal Consulting.
No vendor agendas. No hidden incentives.
Just strategic guidance built entirely around the needs of the mailer".
              {/* "We built Postratics because postal consulting was dominated by vendors with conflicts of interest. Our only client is the mailer." */}
            </p>
            <p className="dm" style={{ fontSize: "13px", letterSpacing: "0.1em", textTransform: "uppercase", opacity: 0.5 }}>— Founding Team, Postratics</p>
          </div>
          <div>
            <p className="dm" style={{ fontSize: "15px", lineHeight: 1.8, opacity: 0.65, fontWeight: 300, marginBottom: "24px" }}>
              Postratics was founded by postal industry veterans who spent decades inside USPS and major mail service providers. We know where the leakage is — and exactly how to stop it.
            </p>
            <p className="dm" style={{ fontSize: "15px", lineHeight: 1.8, opacity: 0.65, fontWeight: 300, marginBottom: "40px" }}>
              We work with nonprofits, publishers, retailers, financial institutions, and government agencies to bring discipline and intelligence to what is often a neglected cost center.
            </p>
            <div style={{ display: "flex", gap: "48px" }}>
              <div>
                <div className="pf" style={{ fontSize: "36px", fontWeight: 900, color: "#C4873A" }}>400+</div>
                <div className="dm" style={{ fontSize: "12px", letterSpacing: "0.1em", textTransform: "uppercase", opacity: 0.5, marginTop: "4px" }}>clients served</div>
              </div>
              <div>
                <div className="pf" style={{ fontSize: "36px", fontWeight: 900, color: "#C4873A" }}>$94M</div>
                <div className="dm" style={{ fontSize: "12px", letterSpacing: "0.1em", textTransform: "uppercase", opacity: 0.5, marginTop: "4px" }}>total savings delivered</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA BLOCK */}
      <section style={{ background: "#1A1714", padding: "100px 60px", textAlign: "center", position: "relative", overflow: "hidden" }} className="section-pad">
        <div style={{
          position: "absolute", inset: 0,
          backgroundImage: "repeating-linear-gradient(0deg, rgba(245,242,235,0.02) 0px, rgba(245,242,235,0.02) 1px, transparent 1px, transparent 48px), repeating-linear-gradient(90deg, rgba(245,242,235,0.02) 0px, rgba(245,242,235,0.02) 1px, transparent 1px, transparent 48px)",
          pointerEvents: "none"
        }} />
        <div style={{ position: "relative" }}>
          <p className="dm" style={{ fontSize: "11px", letterSpacing: "0.25em", textTransform: "uppercase", color: "rgba(245,242,235,0.4)", marginBottom: "24px" }}>
            Start saving today
          </p>
          <h2 className="pf" style={{ fontSize: "clamp(40px, 5vw, 72px)", fontWeight: 900, color: "#F5F2EB", lineHeight: 1.05, letterSpacing: "-0.03em", marginBottom: "24px" }}>
            What's your mail<br />program costing you?
          </h2>
          <p className="dm" style={{ fontSize: "16px", color: "rgba(245,242,235,0.6)", fontWeight: 300, maxWidth: "420px", margin: "0 auto 48px", lineHeight: 1.7 }}>
            A free 30-minute audit with a Postratics consultant reveals exactly where you're overspending — no strings attached.
          </p>
          <div className="cta-stack" style={{ display: "flex", gap: "16px", justifyContent: "center" }}>
            <button className="cta-btn" style={{ background: "#C4873A", color: "#1A1714", fontWeight: 500 }}>Book a Free Audit →</button>
            <button className="cta-btn-outline">Learn More</button>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ padding: "48px 60px", borderTop: "1px solid rgba(26,23,20,0.1)" }} className="section-pad">
        <div className="footer-inner">
          <div>
            <div className="pf" style={{ fontSize: "20px", fontWeight: 700, marginBottom: "6px" }}>Postratics</div>
            <div className="dm" style={{ fontSize: "12px", opacity: 0.4, letterSpacing: "0.08em" }}>USPS Mail Consulting · Est. 2020</div>
          </div>
          <div className="footer-links">
            {["Services", "About", "Case Studies", "Contact", "Privacy"].map(l => (
              <a key={l} href="#" className="nav-link" style={{ fontSize: "12px" }}>{l}</a>
            ))}
          </div>
          <div className="dm" style={{ fontSize: "12px", opacity: 0.35 }}>© 2026 Postratics, LLC</div>
        </div>
      </footer>
</div>
    </div>
  );
}
